import { Controller } from '@hotwired/stimulus';

export default class SignatureController extends Controller {
  static values = {
    subscriptionId: Number,
    errorDisplayDelayInMs: Number,
  };

  connect() {
    this.errorDisplayDelayInMs = 5000;
    this.errorDocliftNotRespondingDelayInMs = 180000;
    this.subscription = App.cable.subscriptions.create(
      {
        channel: 'SignatureChannel',
        subscription_id: this.subscriptionIdValue,
      },
      {
        received: this.handleChannelMessage.bind(this),
        rejected: this.handleChannelRejection.bind(this),
      }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleChannelMessage(data) {
    try {
      if (data.status == 'success') {
        if (data.show_completion) {
          this.showCompletionStep();
        } else if (data.show_generated_message) {
          this.showGeneratedMessage();
        } else if (data.show_generating_message) {
          this.showGeneratingMessage();
        }
      } else {
        this.handleError();
      }
    } catch (error) {
      this.handleError();
    }
  }

  handleChannelRejection() {
    this.handleError();
  }

  showGeneratingMessage() {
    this.dispatch('show-generating');
    this.dispatch('progress-update', { percentage: 25 });
    this.docliftTimeout = setTimeout(
      this.docliftDoesNotAnswer.bind(this),
      this.errorDocliftNotRespondingDelayInMs
    );
  }

  showGeneratedMessage() {
    this.dispatch('show-generated');
    this.dispatch('progress-update', { percentage: 50 });

    if (this.docliftTimeout) {
      clearTimeout(this.docliftTimeout);
      this.docliftTimeout = null;
    }

    setTimeout(() => {
      this.showContractStep();
    }, 2000);
  }

  showContractStep() {
    this.dispatch('load-contract');
    this.dispatch('show-contract');
    this.dispatch('progress-update', { percentage: 75 });
  }

  showCompletionStep() {
    this.dispatch('show-completion');
    this.dispatch('progress-update', { percentage: 100 });
    this.dispatch('breadcrumb-update', {
      step: 4,
      completionText: '4/4 complétée',
    });
  }

  handleError() {
    this.dispatch('show-error', { delay: this.errorDisplayDelayInMs });
  }

  docliftDoesNotAnswer() {
    App.cable.disconnect();
    this.dispatch('show-error', { delay: 0 });
  }

  dispatch(eventName, detail = {}) {
    const event = new CustomEvent(`signature:${eventName}`, {
      bubbles: true,
      detail,
    });
    this.element.dispatchEvent(event);
  }
}
